import { Screen } from '../interfaces';
export const finalSummary: Screen = {
  component: 'summary'
};
